<div class="min-h-screen flex flex-grow items-center justify-center container-not-found">
    <div class="rounded-lg bg-white p-8 text-center containerError">
      <!--<h1 class="mb-4 text-4xl font-bold">404</h1>-->
      <mat-icon class="error">error</mat-icon>
      <p class="mb-6">{{"screen_not_available" | translate}}</p>
      <button class="btnAction mb-4 refresh-btn" (click)="PostAction()">{{"refresh" | translate}}</button>
    </div>
</div>

